module.exports = __webpack_public_path__ + "static/media/iphone.83ea3290.png";